import {Button, Stack, Typography, styled} from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import {FC} from 'react';

interface Props {
  title?: string;
  message?: string;
  close?: () => void;
}

export const ErrorContainer: FC<Props> = ({title = 'Ошибка', message = 'Техническая ошибка системы', close}) => {
  return (
    <Root justifyContent="space-between">
      <BlueBar />

      <Content>
        <TitleRow>
          <HighlightOffOutlinedIcon fontSize="large" color="inherit" />
          <Typography fontWeight={700} variant="h6">
            {title}
          </Typography>
        </TitleRow>

        <BottomSection>
          <Message sx={{whiteSpace: 'pre-line'}}>{message}</Message>

          <OkButton variant="contained" onClick={close}>
            OK
          </OkButton>
        </BottomSection>
      </Content>

      <BlueBar />
    </Root>
  );
};

const Root = styled(Stack)({
  overflow: 'hidden',
  borderRadius: '5px',
  width: '449px',
  minHeight: '258px',
  background: '#fff',
});

const BlueBar = styled(Stack)({
  height: '16px',
  backgroundColor: '#007DFF',
});

const Content = styled(Stack)({
  padding: '16px 0',
  color: '#002033',
  gap: '8px',
});

const TitleRow = styled(Stack)({
  padding: '0 46px',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
});

const Message = styled(Typography)({
  fontSize: '14px',
  fontWeight: 300,
  paddingLeft: '92px',
  paddingRight: '46px',
  maxHeight: '658px',
  overflowY: 'auto',
});

const BottomSection = styled(Stack)({
  gap: '40px',
});

const OkButton = styled(Button)({
  backgroundColor: '#007DFF',
  width: '134px',
  alignSelf: 'center',
  pointerEvents: 'all',

  '&:hover': {
    backgroundColor: '#006be0',
  },
});
